<template>
  <div>
    <button :id="label"       :hidden="processing > -1" :class="`${classes} btn`" @click="click()">{{ label }}</button>
    <button :id="`${label}1`" :hidden="processing == -1" :class="`${!optionsClasses.length ? classes : ''} btn mr-2`" @click="click1()">{{ '' }}</button>
    <button :id="`${label}2`" :hidden="processing == -1 || !options[processing][1]" :class="`${!optionsClasses.length ? classes : ''} btn`" @click="click2()">{{ '' }}</button>
  </div>
</template>

<script>

export default {
    name: 'Button-Options',
    props: {
        id:             { type: String, required: true },
        label:          { type: String, required: true },
        classes:        { type: String, default: '' },
        options:        { type: Array, default() { return [] } }, // [ label1 (, label2) ][]
        optionsClasses: { type: Array, default() { return [] } }, // [ classes1 (, classes2) ][]
        timeout:        { type: Number, default: 8000 }
    },
    data () {
      return {
        processing: -1,
        choices: [],
        lastActionTime: 0
      }
    },
    computed: {
    },
    methods: {
      click () {
        if (this.options.length > 0) {
          this.processing = 0
          this.choices = []
          this.updateButtons()
      }
      else {
        this.$emit('click')
      }
    },
    click1 () {
      this.choices.push(0)
      if (this.options.length > this.processing + 1) {
        this.processing += 1
        this.updateButtons()
      }
      else {
        this.$emit('click', this.choices)
        this.processing = -1
      }
    },
    click2 () {
      this.choices.push(1)
      if (this.options.length > this.processing + 1) {
        this.processing += 1
        this.updateButtons()
      }
      else {
        this.$emit('click', this.choices)
        this.processing = -1
      }
    },
    updateButtons () {
      document.getElementById(`${this.label}1`).innerHTML = this.options[this.processing][0]
      document.getElementById(`${this.label}1`).blur()
      document.getElementById(`${this.label}2`).innerHTML = this.options[this.processing][1]
      document.getElementById(`${this.label}2`).blur()
      this.lastActionTime = new Date().getTime()
      setTimeout(() => {
        if (new Date().getTime() - this.lastActionTime >= this.timeout) {
          this.processing = -1
          this.choices = []
        }
      }, this.timeout)
        
    }
  }

}
</script>

<style>

</style>